import { Component, Inject, Optional } from '@angular/core';
import { MmDialogData, MmDialogRefService } from '@metromarkets/components';

@Component({
  selector: 'app-redirect-from-tier-one-signup-dialog',
  templateUrl: './redirect-from-tier-one-signup-dialog.component.html',
  styleUrls: ['./redirect-from-tier-one-signup-dialog.component.scss'],
})
export class RedirectFromTierOneSignupDialogComponent {
  constructor(@Inject(MmDialogData) public data: string, @Optional() public dialogRef: MmDialogRefService<any>) {}
}
